<template>
    <div>
        <tabs class="monitoring-logframe-tabs" ref="tab-sections" type="info" square>
            <tab-pane id="revised" :label="$t('monitoring.tabs_label__revised_logframe')">
                <card>
                    <revised-logframe></revised-logframe>
                </card>
            </tab-pane>
        </tabs>
        <div class="row" v-if="MonitoringForm.initialized && MonitoringForm.isEditable">
            <div class="col-12">
                <base-button type="default" wide @click.native="saveProgress">{{$t('general.save_progress')}}</base-button>
                <base-button class="pull-right" wide @click.native="submit">{{$t('general.submit')}}</base-button>
            </div>
        </div>
    </div>
</template>
<script>
    import {MonitoringForm} from '@/services';
    import {TabPane, Tabs} from 'src/components';

    import RevisedLogframe from './Logframes/Revised';
    import OriginalLogframe from './Logframes/Original';
    import {EventBus} from "@/event-bus";

    export default
    {
        components:
        {
            MonitoringForm,
            Tabs,
            TabPane,
            RevisedLogframe,
            OriginalLogframe,
        },
        data()
        {
            return {
                MonitoringForm,
                showContractDetails: false,
                startDate: '',
                endDate: '',
                moment: '',
                regions: [],

            }
        },
        computed:
        {

        },
        async beforeMount()
        {

        },
        methods:
        {
            getError(field)
            {
                return this.errors.first(field);
            },
            validate()
            {
                return this.$validator.validateAll().then(res =>
                {
                    this.$emit('on-validated', res, this.model);

                    return res;
                });
            },
            setRegion(ev)
            {
                MonitoringForm.regionId = parseInt(ev.target.value);
                MonitoringForm.model.grant_agreement.acp_country;
            },
            viewOriginalProposal()
            {
                window.open('/application/fill/' + MonitoringForm.grantId + '/' + MonitoringForm.applicationId, '_blank');
            },

            saveProgress()
            {
                EventBus.$emit('monitoring-save-progress');
            },

            submit()
            {
                EventBus.$emit('monitoring-submit');
            },
        },
    };
</script>
